import { CustomValidators } from './../../shared/Validators/custom-validators';

import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { SettingsService } from '../settings.service';
import { AlertService } from 'src/app/shared/toast/alert.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {

  ngOnDestroy(): void {

    this.clearLocalVarialbles();
  }

  clearLocalVarialbles() {
    this.showHistoryButton = null;

    this.changePasswordForm = null;
  }

  public showHistoryButton: boolean = true;
  public title: string = "ChangePassword";
  public subTitle: string;

  changePasswordForm: FormGroup;
  type: string = 'password'
  error:string=""
  @ViewChild("password") password
  constructor(
    private route: Router,
    private fb: FormBuilder,
    public customLoadingService: CustomLoadingService,
    public service: SettingsService,
    private toastService: AlertService,
    private translateService: TranslateService

  ) {
    this.changePasswordForm = fb.group({
      'password': ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      'newPassword': ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator, CustomValidators.nospaceValidator, Validators.minLength(8), CustomValidators.validatePassword])],
      'confirmPassword': ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
    }, { validator: this.MatchingPasswords('newPassword', 'confirmPassword') });
  }
  changeType() {

    if (this.password.nativeElement.type == 'password')
      this.password.nativeElement.type = 'text'
    else

      this.password.nativeElement.type = 'password'


  }
  ngOnInit() {
    try {

    } catch (error) {
    }
  }

  MatchingPasswords(passwordKey: string, confirmPasswordKey: string) {
    try {

      return (group: FormGroup): { [key: string]: any } => {
        let password = group.controls[passwordKey];
        let confirmPassword = group.controls[confirmPasswordKey];

        if (password.value !== confirmPassword.value) {
          return {
            mismatchedPasswords: true
          };
        }
      }
    } catch (error) {

    }
  }

  submitForm(model: any, isValid: boolean) {
    try {
      if (isValid) {
        this.customLoadingService.show();
        model.isRegistration = false;

        this.service.changePassword(model)

          .subscribe(res => {
            //   console.log("test",res.Message.Status);
            if (res == "1") {
            
              this.toastService.success(this.translateService.instant("ChangePassword.Message.Success"), { keepAfterRouteChange: false });
     
             
              this.route.navigate(["/settings"])
            }
            if (res == "0") {
                 this.error= this.translateService.instant("ChangePassword.Message.Failed");
              this.changePasswordForm.reset();
            }
          },
            error => {
              this.customLoadingService.hide();
            },
            () => {
              this.customLoadingService.hide();
            });
      }
    } catch (error) {
      this.customLoadingService.hide();
    }

  }
}
